export const SCORING_EXPORT_TRANSLATION_KEYS = {
    successToast: "si.pages.score_settings.export.success",
    errorToast: "si.pages.score_settings.export.error",
    tooltip: "si.pages.score_settings.export.tooltip",
    criterionType: {
        signal: "si.pages.score_settings.export.criterion_type.signal",
        filter: "si.pages.score_settings.export.criterion_type.filter",
    },
} as const;
